import {
  Component,
  Injector,
  EventEmitter,
  Output,
} from '@angular/core';
import { finalize } from 'rxjs/operators';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { forEach as _forEach, map as _map } from 'lodash-es';
import { AppComponentBase } from '@shared/app-component-base';
import {
  AnexarExameDto,
  ConsultaDto,
  ConsultaServiceProxy,
} from '@shared/service-proxies/service-proxies';

@Component({
  templateUrl: './anexar-exame-dialog.component.html',
  styleUrls: ['./anexar-exame-dialog.component.scss'],
})
export class AnexarExameDialogComponent extends AppComponentBase {
  saving = false;
  consulta: ConsultaDto;
  exame: AnexarExameDto = null;
  solicitacaoId: string;
  @Output() onSave = new EventEmitter<any>();
  @Output() onCancel = new EventEmitter<any>();

  constructor(
    injector: Injector,
    private readonly bsModalRef: BsModalRef,
    private readonly _consultaService: ConsultaServiceProxy

  ) {
    super(injector);
  }

  cancel() {
    this.bsModalRef.hide();
    this.onCancel.emit();
  }

  handleUpload(event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    this.exame = new AnexarExameDto();
    this.exame.consultaId = this.consulta.id;
    this.exame.solicitacaoId = this.solicitacaoId;
    this.exame.fileNameWithOutExtension = file.name;
    this.exame.tipoArquivo = file.type;
    this.exame.tamanhoArquivo = file.size;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.exame.base64File = reader.result.toString();
    };
  }


  save(): void {
    if (!this.exame) {
      return;
    }

    if (this.exame.base64File) {
      if (this.exame.tipoArquivo != '') {
        const splitFile = this.exame.fileNameWithOutExtension.split('.');
        this.exame.extension = splitFile[splitFile.length - 1];
        splitFile.pop();
        this.exame.fileNameWithOutExtension = splitFile.join('.');
      }

      this.saving = true;
      abp.ui.setBusy();
      this._consultaService
        .anexarExame(this.exame)
        .pipe(
          finalize(() => {
            abp.ui.clearBusy();
          })
        )
        .subscribe((x) => {
          this.notify.info("Prescrição anexada com sucesso");
          this.bsModalRef.hide();
          this.onSave.emit();
        });

    }
  }
}



